// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__25u-i","alert":"SettungsInbox_alert__2Pp0T"};